import './DataTable.scss';
import Control from "../../Control";
import NP, {EventArgs, IHash} from "../../NP";
import Label from "../Label/Label";
import IconToggleButton from "../IconToggleButton/IconToggleButton";
import Delegate from "../../Delegate";
import {moveItemInArray} from "../../../10. Battle/Util";

let S = require('string');
let moment = require('moment');

export interface IColumnDataTable {
	Width: string,
	Content: string,
	PropertyContent: string,
	HtmlPropertyContent: string,
	FirstColumn: boolean,
	SecondColumn: boolean,
	Type: string,
	Class: string
}

export default class DataTable extends Control {
	public EvScrolled: Delegate;
	private _Columns: IColumnDataTable[];
	private _Rows: IHash<string>[];
	private _ShowSettingsButton: boolean;
	private _ShowColumns: boolean;
	private _HideColumnsIfEmpty: boolean;
	private _FullHeight: boolean;
	private _ShowPaginator: boolean;
	private _ShowRowIndex: boolean;
	private _DisableHeadersEvents: boolean;
	private _MultiSelect: boolean;
	private _ImageWidth: number;
	private _ImagesColumn: number;
	private _IsSmall: boolean;
	private _sortColumn: number;
	private _sortDirection: number;
	private _list: HTMLElement;
	private _header: HTMLElement;
	private _pag: HTMLElement;
	private _pagLbl: Label;
	private _leftPagBtn: IconToggleButton;
	private _rightPagBtn: IconToggleButton;
	private _IsRowSelected: (row: IHash<string>) => boolean;
	private EvItemClick: Delegate;
	private EvItemContextMenu: Delegate;
	private EvSortClick: Delegate;
	private EvPaginatorLeftClick: Delegate;
	private EvPaginatorRightClick: Delegate;
	private EvSelectionChanged: Delegate;
	private _selectAllSpan: HTMLElement;
	private _buttons: IconToggleButton[];
	private EvRowMoved: Delegate;
	private _PropFilter: string;
	private _FilterText: string;
	private _selection: IHash<string>[];
	private _sortIndicator: HTMLElement;

	private _EnableSort: boolean;
	private _SortFunc: Function;
	private _CustomSettingsButton: object[];
	_CustomSettingsHeader: string

	_CustomSettingsButtonCreated: Function;
	private _HeaderPaddingRight: string;
	_CanDragRows: boolean;
	private _ExPaginatorNode: HTMLElement;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._CanDragRows = false;
		this._EnableSort = true;
		this._Columns = [];  //{Width: '40%', Content: 'text', PropertyContent: 'Date', FirstColumn: true, SecondColumn: true}  //FirstColumn: true, SecondColumn: true  - эти колонки используются для малой ширины
		this._Rows = [];    //{Prop1: 'Value', Prop2: 'asd'}
		this._ShowSettingsButton = false;
		this._ShowColumns = true;
		this._ShowRowIndex = false;
		this._DisableHeadersEvents = false;
		this._HideColumnsIfEmpty = true;
		this._FullHeight = false;
		this._ShowPaginator = false;
		this._MultiSelect = false;
		this._ImageWidth = 24;
		this._ImagesColumn = -1; // номер колонки куда будут вставляться картинки из строки (свойство row.TextImages)
		this._SortFunc = null;
		this._IsRowSelected = null;
		this._CustomSettingsButton = null;
		this._HeaderPaddingRight = null;
		this._ExPaginatorNode = null
		this.EvRowMoved = new Delegate();
		this.EvItemClick = new Delegate();
		this.EvItemContextMenu = new Delegate();
		this.EvSortClick = new Delegate();
		this.EvPaginatorLeftClick = new Delegate();
		this.EvPaginatorRightClick = new Delegate();
		this.EvSelectionChanged = new Delegate();
		this.EvScrolled = new Delegate();
		this._CustomSettingsHeader = null;
		this._CustomSettingsButtonCreated = null;
		super._initFields(settings);
	}

	_render()
	{
		this._selection = [];
		this._sortDirection = 1;  //asc
		this._sortColumn = -1;
		this._IsSmall = false;
		this.np_render(`<div class="mdc-data-table app-list--non-interactive"><div class="mdc-data-table__header app-list-item"></div><ul class="app-list"></ul></div>`);
		if (NP.isTouchDevice())
			this.addClass('mdc-data-table--touch');
		if (this._FullHeight)
			this.addClass('mdc-data-table--fullheight');
		this._header = this._root.querySelector('.mdc-data-table__header');
		this._list = this._root.querySelector('.app-list');

		if (this._MultiSelect)
		{
			this._selectAllSpan = NP.parseHTMLC(`<span class="app-list-item__graphic check-box ${NP.FontImages.check_box_outline_s}"></span>`);
			this._header.appendChild(this._selectAllSpan);
			this.addEvent(this._selectAllSpan, 'click', this._selectAllClick);
		}
		else if (this._CanDragRows && !this._ShowRowIndex)
		{
			this._header.appendChild(NP.parseHTMLC(`<span class="app-list-item__graphic" style="margin-right: 16px"></span>`));
		}

		if (this._ShowRowIndex)
		{
			let s = NP.parseHTMLC('<span class="app-list-item__text app-list-item__index">№</span>');
			if (this._CanDragRows)
				s.style.marginRight = '60px'
			this._header.appendChild(s);
		}

		this._Columns.forEach((col, index) =>
		{
			let span = NP.parseHTMLC(`<span class="app-list-item__text" index="${index}" style="${col.Width ? 'width: ' + col.Width : ''}">${S(col.Content || '').escapeHTML().s}</span>`);
			this._header.appendChild(span);
			this.addEvent(span, 'click', this.onHeaderItemClick);
		});

		if (this._CustomSettingsHeader)
		{
			let node = NP.createNode(this._header)
			node.style.whiteSpace = 'nowrap';
			node.innerHTML = this._CustomSettingsHeader;
		}

		if (this._ShowColumns)
		{
			if (this._ShowSettingsButton)
				NP.createNode(this._header, 'app-list-item__meta');
		}
		else
			NP.hideNode(this._header);

		if (this._ShowPaginator)
		{
			this._pag = NP.createNode(this._root, 'paginator-node');

			if (this._ExPaginatorNode)
				this._pag.appendChild(this._ExPaginatorNode)

			this._pagLbl = new Label({ParentNode: this._pag, Class: 'selectable'});

			this._leftPagBtn = new IconToggleButton({
				ParentNode: this._pag,
				FontImage: NP.FontImages.chevron_left,
				EvClick: () => this.EvPaginatorLeftClick.fire(this)
			});

			this._rightPagBtn = new IconToggleButton({
				ParentNode: this._pag,
				FontImage: NP.FontImages.chevron_right,
				EvClick: () => this.EvPaginatorRightClick.fire(this)
			});
		}
		this.addEvent(this._list, 'scroll', () =>
		{
			this.EvScrolled.fire(this, {
				scroll: this._list.scrollTop,
				isSmall: this._IsSmall
			});
		});

		this.refresh();
	}

	updateColumnCaption(index: number, value: string)
	{
		this._header.querySelector(`.app-list-item__text[index="${index}"]`).innerHTML = S(value).escapeHTML().s;
	}

	setShowPaginator(value: boolean)
	{
		this._ShowPaginator = value;
		NP.setIsVisible(this._pag, value);
	}

	updatePagCaption(text: string)
	{
		this._pagLbl.setContent(text);
	}

	getLeftPagButton()
	{
		return this._leftPagBtn;
	}

	getRightPagButton()
	{
		return this._rightPagBtn;
	}

	setMultiSelect(value: boolean)
	{
		if (this._MultiSelect != value)
		{
			this._MultiSelect = value;
			NP.setIsVisible(this._selectAllSpan, value);
		}
	}

	setEnableSort(value: boolean)
	{
		this._EnableSort = value;
	}

	private onHeaderItemClick(s: object, a: EventArgs)
	{
		//EvSortClick
		let colIndex = parseInt((a.Event.target as HTMLElement).getAttribute("index"));
		if (this._EnableSort && !isNaN(colIndex))
		{
			this.clearSelection();
			this._sortDirection = -this._sortDirection;
			this._sortColumn = colIndex;
			let e = {Column: colIndex, Direction: this._sortDirection, CancelSort: false};
			this.EvSortClick.fire(this, e);
			if (!e.CancelSort)
				this.sort(colIndex, this._sortDirection);
			this._refreshSort();
		}
	}

	sort(column: number, direction: number)
	{
		this._sortColumn = column;
		this._sortDirection = direction;
		let prop = this._Columns[column].PropertyContent || this._Columns[column].HtmlPropertyContent;
		let rows;
		if (this._SortFunc)
			rows = this._Rows.sort((a, b) =>
			{
				return this._SortFunc(a, b, prop, this._sortDirection);
			});
		else
			rows = this._Rows.sort((a, b) =>
			{
				if (a[prop] == b[prop])
					return 0;

				if (a[prop] > b[prop])
					return this._sortDirection;

				if (a[prop] < b[prop])
					return -this._sortDirection;
			});

		this.refresh(rows);
	}

	_refreshSort()
	{
		if (!this._sortIndicator)
			this._sortIndicator = NP.createNode(null, 'sort-indicator', 'span');

		if (this._sortIndicator.parentNode)
			this._sortIndicator.parentNode.removeChild(this._sortIndicator);

		if (this._sortDirection == -1)
		{
			this._sortIndicator.classList.remove(NP.FontImages.arrow_upward);
			this._sortIndicator.classList.add(NP.FontImages.arrow_downward);
		}
		else
		{
			this._sortIndicator.classList.remove(NP.FontImages.arrow_downward);
			this._sortIndicator.classList.add(NP.FontImages.arrow_upward);
		}

		if (this._sortColumn > -1 && this._header.childNodes.item(this._sortColumn + 1))
		{
			this._header.querySelector(`.app-list-item__text[index="${this._sortColumn}"]`).appendChild(this._sortIndicator);
			//if (colSpan != this._sortIndicator.parentNode)
			//	colSpan.insertBefore(this._sortIndicator, colSpan.firstChild);
		}
	}

	updateSortIndicator(column: number, direction: number)
	{
		this._sortColumn = column;
		this._sortDirection = direction;
		this._refreshSort();
	}

	addRows(rows: IHash<any>[])
	{
		this._Rows = [...this._Rows, ...rows];
		this.refresh(rows, false)
	}

	addRow(row: IHash<any>)
	{
		this._Rows.push(row)
		this.refresh()
	}

	addRowAfter(newRow: IHash<any>, afterRow: IHash<any>)
	{
		NP.insertToArray(this._Rows, newRow, this._Rows.indexOf(afterRow) + 1)
		this.refresh()
	}

	removeRow(row: IHash<any>)
	{
		NP.removeFromArray(this._Rows, row)
		this.refresh()
	}

	setRows(rows: IHash<any>[], applySort?: boolean)
	{
		this._Rows = rows;
		this._selection = [];
		this.refresh();
		if (applySort && this._sortColumn > -1)
			this.sort(this._sortColumn, this._sortDirection);
	}

	setSortState(column: number, direction: number)
	{
		this.updateSortIndicator(column, direction);
		this.sort(this._sortColumn, this._sortDirection);
	}

	getSortState()
	{
		return {
			Field: this._sortColumn,
			Direction: this._sortDirection
		};
	}

	getRows()
	{
		return this._Rows;
	}

	refresh(rows?: IHash<string>[], clearHtml: boolean = true)
	{
		if (clearHtml)
		{
			this._list.innerHTML = "";
			this._destroyArray(this._buttons);
			this._buttons = [];
		}

		let originalRows = rows || this._Rows;

		if (this._FilterText && this._PropFilter)
			rows = originalRows.filter(row =>
			{
				let value = row[this._PropFilter] && row[this._PropFilter].toLowerCase();
				return value && value.indexOf(this._FilterText) > -1;
			});
		else
			rows = originalRows;

		let firstPropContent = (this._Columns.find(col => col.FirstColumn) || this._Columns[0]).PropertyContent || this._Columns[0].HtmlPropertyContent,
			 secPropContent = this._Columns.length > 1 ? (this._Columns.find(col => col.SecondColumn) || this._Columns[1]).PropertyContent || this._Columns[0].HtmlPropertyContent : null,
			 fragment = document.createDocumentFragment(),
			 index = 0,
			 dt = NP.getDayTimeFormat();


		for (let row of rows)
		{
			row.ToolTip = row.ToolTip || row.Name || row.Caption;
			let li = this._createRow(row, firstPropContent, secPropContent, dt, originalRows == rows ? index : originalRows.indexOf(row));
			fragment.appendChild(li);

			if (this._ShowSettingsButton)
				this._buttons.push(new IconToggleButton({
					ParentNode: li,
					FontImage: NP.FontImages.more_vert,
					Class: 'app-list-item__meta',
					Data: row,
					EvClick: (s: Control, e: EventArgs) =>
					{
						e.Event.stopPropagation();
						e.Event.preventDefault();
						this.EvItemContextMenu.fire(this, {
							Item: s.getData(),
							Node: e.Event.target,
							Event: e.Event
						});
					}
				}));


			if (this._CustomSettingsButton && !row.IsHeader)
			{
				for (let i = 0; i < this._CustomSettingsButton.length; i++)
				{
					let st = this._CustomSettingsButton[i];
					let btn = new IconToggleButton({
						ParentNode: li,
						Data: row,
						...st
					});
					this._buttons.push(btn);

					if (this._CustomSettingsButtonCreated)
						this._CustomSettingsButtonCreated(btn, i)
				}
			}

			index++;
		}
		this._list.appendChild(fragment);

		this._updateSpanAllSelected();
		this._refreshSort();
		this._updateFirstHeaderCol(!!(rows[0] && (rows[0].FontImage || rows[0].Image)));

		if (this._HideColumnsIfEmpty)
		{
			NP.setIsVisible(this._header, this._Rows.length);
			if (this._ShowPaginator)
				NP.setIsVisible(this._pag, this._Rows.length);
		}
		else
			NP.setIsVisible(this._pag, true);

		if (this._IsSmall)
		{
			NP.addCssClass(this._list, 'app-list--two-line');
			NP.hideNode(this._header);
		}
		else
			NP.removeCssClass(this._list, 'app-list--two-line');

		this._updateHeight();

	}


	_updateFirstHeaderCol(hasImage: boolean)
	{
		let colIndex = this._ShowRowIndex ? 1 : 0;
		if (this._Columns[colIndex].Width)
		{
			let col = this._header.querySelector('.app-list-item__text[index="0"]') as HTMLElement;

			if (this._MultiSelect && hasImage && !this._IsSmall)
				col.style.width = `calc(${this._Columns[colIndex].Width} + ${this._ImageWidth}px + 32px)`;
			else
				col.style.width = this._Columns[colIndex].Width;
		}
	}

	_createRow(row: IHash<string>, firstPropContent: string, secPropContent: string, dt: string, index: number)
	{
		let cnt = '',
			 img = '',
			 rowIndex = '';

		if (row.IsHeader)
		{
			return NP.parseHTMLC(`<li class="app-list-item">${row.Content}</li>`);
		}

		if (this._ShowRowIndex && !this._IsSmall)
		{
			rowIndex = `<span class="app-list-item__span app-list-item__index">${index + 1}</span>`;
		}

		if (this._MultiSelect && !this._IsSmall)
		{
			if (row.FontImage)
				img = `<span class="app-list-item__graphic check-box ${NP.FontImages.check_box_outline_s}"></span><span class="app-list-item__graphic ${row.FontImage}"></span>`;
			else if (row.Image)
				img = `<span class="app-list-item__graphic check-box ${NP.FontImages.check_box_outline_s}"></span><span class="app-list-item__graphic">${row.Image}</span>`;
			else
				img = `<span class="app-list-item__graphic check-box ${NP.FontImages.check_box_outline_s}"></span>`;
		}
		else if (row.FontImage)
			img = `<span class="app-list-item__graphic ${row.FontImage}"></span>`;
		else if (row.Image)
			img = `<span class="app-list-item__graphic">${row.Image}</span>`;

		let titleAttr = row.ToolTip ? `title="${row.ToolTip}"` : "";

		if (this._IsSmall)
		{
			let cellValue = S(row[firstPropContent] || '').escapeHTML().s,
				 secLine = S(row[secPropContent] || '').escapeHTML().s;

			if (row.TextImages)
				secLine = (row.TextImages as any).map((fontImage: string) => `<span class="${fontImage} mdc-data-table__cell-image-small-list"></span>`).join(' ') + secLine;

			if (row.highlightIndex && !isNaN(parseInt(row.highlightIndex)) && parseInt(row.highlightIndex) > 0)
				cnt = `<span class="app-list-item__text mdc-data-table__first-column" ${titleAttr}>` +
					 (this._IsSmall ? `<span class="app-list-item__primary-text">${secLine}</span>` : secLine) +
					 `<span class="app-list-item__secondary-text">${cellValue}</span>` +
					 `</span>`;
			else
				cnt = `<span class="app-list-item__text mdc-data-table__first-column" ${titleAttr}>` +
					 (this._IsSmall ? `<span class="app-list-item__primary-text">${cellValue}</span>` : cellValue) +
					 `<span class="app-list-item__secondary-text">${secLine}</span>` +
					 `</span>`;
		}
		else
		{
			for (let i = 0; i < this._Columns.length; i++)
			{
				let col = this._Columns[i],
					 cellValue = col.HtmlPropertyContent ? (row[col.HtmlPropertyContent] || '') :
						  S(row[col.PropertyContent] == undefined ? '' : row[col.PropertyContent]);

				if (col.Type == 'Date')
					cellValue = cellValue ? moment(cellValue).format(dt) : '';

				let icon = "";
				if (i == this._ImagesColumn && row.TextImages)
				{
					icon = (row.TextImages as any).map((fontImage: string) => `<span class="${fontImage} mdc-data-table__cell-image"></span>`).join(' ');
				}

				let cls = '';
				if (row.highlightIndex && !isNaN(parseInt(row.highlightIndex)))
					cls = i == parseInt(row.highlightIndex) ? 'mdc-data-table__first-column' : '';
				else
					cls = i == 0 ? 'mdc-data-table__first-column' : '';

				let txt_span = `<span class="app-list-item__text">${cellValue}</span>`;
				if (i == 0 && img && col.Width && col.Width.indexOf('%') > -1 && !this._MultiSelect)
					cnt += `<span class="${cls}" ${titleAttr} style="width: calc(${col.Width} - 60px)">${txt_span + icon}</span>`;
				else
					cnt += `<span class="${cls} app-list-item__span ${col.Class}" ${titleAttr} style="${col.Width ? 'width: ' + col.Width : ''}">${txt_span + icon}</span>`;
			}
		}

		let dragSpan = ''
		if (this._CanDragRows)
		{
			dragSpan = `<span class="app-list-item__graphic ${NP.FontImages.drag_handle} grid-drag-item"></span>`
		}

		let rowElement: HTMLElement = NP.parseHTMLC(`<li class="app-list-item" index="${index}">${rowIndex}${dragSpan}${img}${cnt}</li>`);
		if (row.CssClass)
			rowElement.classList.add(row.CssClass);
		if (this._MultiSelect && this._IsRowSelected && this._IsRowSelected(row))
		{
			let checkBox = rowElement.querySelectorAll<HTMLElement>('.check-box')[0];
			this._selectRow(row, checkBox);
		}

		if (this._CanDragRows)
		{
			rowElement.querySelector('.grid-drag-item').addEventListener('mousedown', (e) => this.startDrag(e as any, row, index))
		}

		return rowElement;
	}

	startDrag(e: MouseEvent, row: any, index: number)
	{
		e.preventDefault();
		e.stopPropagation()


		let dragNode = NP.createNode(document.body);

		dragNode.innerText = `${row.RedName} vs ${row.BlueName}`;
		dragNode.classList.add('grid-moving-row')

		dragNode.style.left = e.clientX + 'px'
		dragNode.style.top = (e.clientY - 24) + 'px'

		this._list.classList.add('drag-mode')

		document.onmouseup = (moveEv: MouseEvent) =>
		{
			this._root.onmousemove = null;
			document.onmouseup = null;
			document.body.removeChild(dragNode)

			this._list.classList.remove('drag-mode')

			let li = moveEv.target as HTMLElement;
			while (li.tagName != 'LI')
			{
				li = li.parentNode as HTMLElement;
				if (li.tagName == 'UI')
					return;
			}

			let hoverIndex = parseInt(li.getAttribute('index'))
			if (!isNaN(hoverIndex) && hoverIndex != index)
			{
				let args = {Row: row, Index: hoverIndex}
				this.EvRowMoved.fire(this, args);
			}
			else
				return;
		}

		this._root.onmousemove = (moveEv: MouseEvent) =>
		{
			dragNode.style.left = moveEv.clientX + 'px'
			dragNode.style.top = (moveEv.clientY - 24) + 'px'
		}
	}

	moveRow(row, newIndex: number)
	{
		let movingItem = this._Rows.find(r => r == row);
		let movingIndex = this._Rows.findIndex(b => b == movingItem);

		moveItemInArray(this._Rows, movingIndex, newIndex);
		this.refresh()
	}

	setFilter(propContent: string, text: string)
	{
		if (text != this._FilterText || this._PropFilter != propContent)
		{
			this._FilterText = text ? text.trim() : '';
			this._PropFilter = propContent;
			this.refresh();
		}
	}

	_updateHeight()
	{
		let h = (this._ShowPaginator && this._pag && !NP.hasCssClass(this._pag, 'hide') ? this._pag.offsetHeight : 0)
			 + (this._ShowColumns && this._header && !NP.hasCssClass(this._header, 'hide') ? this._header.offsetHeight : 0);
		if (!NP.hasCssClass(this._header, 'hide'))
		{
			if (this._Height)
				this._list.style.height = (this._Height - 8 - h) + 'px';   //8 - Это margin
			else
				this._list.style.height = `calc(100% - 8px - ${h}px)`;
			this._updateScroll();
		}
		else
		{
			if (this._Height)
				this._list.style.height = (this._Height - 16 - h) + 'px';
			else
				this._list.style.height = '';
		}
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		this._updateHeight();
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		if (this._ShowColumns)
		{
			let old = this._IsSmall;
			this._IsSmall = value <= 797;
			if (old != this._IsSmall)
			{
				this.refresh();
				this._updateHeight();
			}
		}
	}

	getIsSmall()
	{
		return this._IsSmall;
	}

	_getItemByEvent(event: Event)
	{
		let li = event.target as HTMLElement;
		for (let i = 0; i < 10; i++)
		{
			if (li == this._root)
				return;
			if (li.tagName.toLowerCase() == 'li')
				return this._Rows[parseInt(li.getAttribute('index'))];
			else
				li = li.parentNode as HTMLElement;
		}
	}

	_selectAllClick()
	{
		if (this._selection.length > 0)
			this.clearSelection();
		else
			this.selectAll();
		this.EvSelectionChanged.fire(this);
	}

	_selectRow(row: IHash<string>, imgSpan: HTMLElement)
	{
		if (imgSpan.classList.contains(NP.FontImages.check_box_s))
		{
			NP.removeFromArray(this._selection, row);
			this._setSpanSelected(imgSpan, false);
		}
		else
		{
			this._selection.push(row);
			this._setSpanSelected(imgSpan, true);

		}
		this._updateSpanAllSelected();
	}

	setRowSelected(row: IHash<string>, value: boolean)
	{
		let idx = this._Rows.indexOf(row);
		if (idx == -1)
			return;
		let imgSpan = this._root.querySelector(`li.app-list-item[index="${idx}"] > .app-list-item__graphic:first-child`) as HTMLElement;
		if (value)
		{
			if (this._selection.indexOf(row) > -1)
				return;
			this._selection.push(row);
			this._setSpanSelected(imgSpan, true);
		}
		else
		{
			NP.removeFromArray(this._selection, row);
			this._setSpanSelected(imgSpan, false);
		}
		this._updateSpanAllSelected();
	}

	setSelection(rows: IHash<string>[])
	{
		this.clearSelection();

		for (let row of rows)
		{
			let idx = this._Rows.indexOf(row);
			if (idx > -1)
			{
				let imgSpan = this._root.querySelector(`li.app-list-item[index="${idx}"] > .app-list-item__graphic:first-child`) as HTMLElement;
				this._selection.push(row);
				this._setSpanSelected(imgSpan, true);
			}
		}

		this._updateSpanAllSelected();
	}

	updateRow(row: IHash<string>)
	{
		let idx = this._Rows.indexOf(row);
		if (idx == -1)
			return false;
		let domLi = this._root.querySelector(`li.app-list-item[index="${idx}"]`);

		let newLi = this._createRow(row, null, null, NP.getDayTimeFormat(), idx);

		domLi.innerHTML = newLi.innerHTML;

		if (this._ShowSettingsButton)
			this._buttons.push(new IconToggleButton({
				ParentNode: domLi,
				FontImage: NP.FontImages.more_vert,
				Class: 'app-list-item__meta',
				Data: row,
				EvClick: (s: Control, e: EventArgs) =>
				{
					e.Event.stopPropagation();
					e.Event.preventDefault();
					this.EvItemContextMenu.fire(this, {
						Item: s.getData(),
						Node: e.Event.target,
						Event: e.Event
					});
				}
			}));

		if (this._CustomSettingsButton && !row.IsHeader)
		{
			for (let i = 0; i < this._CustomSettingsButton.length; i++)
			{
				let st = this._CustomSettingsButton[i];
				let btn = new IconToggleButton({
					ParentNode: domLi,
					Data: row,
					...st
				});
				this._buttons.push(btn);

				if (this._CustomSettingsButtonCreated)
					this._CustomSettingsButtonCreated(btn, i)
			}
		}

		return true;
	}

	_onClicked(sender: object, args: EventArgs)
	{
		let row = this._getItemByEvent(args.Event);
		if (row)
		{
			let imgSpan = args.Event.target as HTMLElement;
			if (imgSpan.className.indexOf('check-box') == -1)
				imgSpan = imgSpan.parentNode as HTMLElement;

			if (this._MultiSelect && imgSpan.className.indexOf('check-box') > -1)
			{
				this._selectRow(row, imgSpan);
				this.EvSelectionChanged.fire(this);
			}
			else
			{
				this.EvItemClick.fire(this, {Item: row, Event: args.Event});
			}
		}
	}

	_updateSpanAllSelected()
	{
		if (this._selectAllSpan)
		{
			this._selectAllSpan.classList.remove(NP.FontImages.indeterminate_checkbox_s);
			this._selectAllSpan.classList.remove(NP.FontImages.check_box_s);
			this._selectAllSpan.classList.remove(NP.FontImages.check_box_outline_s);

			if (this._selection.length == this._Rows.length)
				this._selectAllSpan.classList.add(NP.FontImages.check_box_s);
			else if (this._selection.length == 0)
				this._selectAllSpan.classList.add(NP.FontImages.check_box_outline_s);
			else
				this._selectAllSpan.classList.add(NP.FontImages.indeterminate_checkbox_s);
		}
	}

	_setSpanSelected(span: HTMLElement, value: boolean)
	{
		if (value)
		{
			span.classList.add(NP.FontImages.check_box_s);
			span.classList.remove(NP.FontImages.check_box_outline_s);
		}
		else
		{
			span.classList.add(NP.FontImages.check_box_outline_s);
			span.classList.remove(NP.FontImages.check_box_s);
		}
	}

	getSelection()
	{
		return this._selection;
	}

	_onContextMenu(sender: object, args: EventArgs)
	{
		let row = this._getItemByEvent(args.Event);
		if (row)
			this.EvItemContextMenu.fire(this, {Item: row, Node: args.Event.target, Event: args.Event});
	}

	selectAll()
	{
		this._selection = this._Rows.slice();
		this._updateSpanAllSelected();
		let spans = this._list.querySelectorAll('li > .app-list-item__graphic:first-child');
		// @ts-ignore
		for (let span of spans)
			this._setSpanSelected(span as HTMLElement, true);
	}

	clearSelection()
	{
		this._selection = [];
		this._updateSpanAllSelected();
		let spans = this._list.querySelectorAll('li > .app-list-item__graphic:first-child');
		// @ts-ignore
		for (let span of spans)
			this._setSpanSelected(span as HTMLElement, false);
	}

	_updateScroll()
	{
		const scrollSize = this._list.offsetWidth - this._list.scrollWidth;

		if (this._HeaderPaddingRight)
		{
			if (scrollSize > 0)
				this._header.style.paddingRight = (parseInt(this._HeaderPaddingRight) - 30) + 'px';
			else
				this._header.style.paddingRight = (parseInt(this._HeaderPaddingRight) - 50) + 'px';
		}
		else
			this._header.style.paddingRight = scrollSize > 0 ? '35px' : '';

	}

	getPaginatorNode()
	{
		return this._pag;
	}
}